/**
 * @fileoverview Phone input Spanish (ES) bundle — the same key set as `en.js`, leaf for leaf.
 * @package @puffin-core/phone-ui
 *
 * Machine-authored (PACKAGE-I18N-SEAT U3, 2026-10-23) and recorded as `'machine'` in `_meta.js`, so every
 * leaf is in the native-speaker review queue rather than passing as reviewed copy. Register: *usted*.
 *
 * @module @puffin-core/phone-ui/strings/es
 */

export const PHONE_UI_ES = Object.freeze({
  // The country picker (`components/CountryDropdown.jsx`)
  countryCodeLabel: 'Código de país: +{{callingCode}}',
  selectCountry: 'Seleccione un país',
  searchCountriesPlaceholder: 'Buscar países...',
  searchCountries: 'Buscar países',
  noCountriesFound: 'No se encontraron países',
  // The field's blur validation (`hooks/usePhoneInput.js`) — page-shell's reviewed wording, moved byte for byte
  invalidPhone: 'Introduzca un número de teléfono válido',
});

export default PHONE_UI_ES;
